import { Injectable } from '@angular/core';
import { User } from '@tcc-mono/vandijk/shared/data-access/models';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Observable } from 'rxjs';
import { UserService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';

@Injectable({
  providedIn: 'root'
})
export class UserRepository extends CoreRepository<User> {

  public users$: Observable<User[]> = this.entities$;
  public selectedUser$: Observable<User> = this.activeEntity$;

  public constructor(
    protected readonly _userService: UserService
  ) {
    super(
      { name: 'users' },
      _userService
    )
  }
}
